// 公共common
import { request } from '@/utils/service'

/** 查询经脉列表 */
export function getMeridianList(params?: string) {
  return request<Record<string, any>>({
    url: 'CommonApi/Meridian/GetMeridianList',
    method: 'get',
    params,
  })
}
/** 查询单位列表 */
export function getUnitList(params?: Object) {
  return request<Record<string, any>>({
    url: 'CommonApi/Common/GetUnitList',
    method: 'get',
    params,
  })
}
/** 获取字库列表 */
export function getTermBank(params?: Object) {
  return request({
    url: 'CommonApi/TermBank/GetTermBank',
    method: 'get',
    params,
  })
}

/** 获取枚举数据（type: 1-国籍、2-字典类型、3-证件类型） */
export function getEnumData(params: Record<string, any>, options?: Record<string, any>) {
  return request<{ key: number; val: string }[]>(
    {
      url: 'CommonApi/Common/GetEnumData',
      method: 'get',
      params,
    },
    options,
  )
}
/** 获取字库分组列表 */
export function getTermBankGroup(params: Object) {
  return request<Record<string, any>[]>({
    url: 'CommonApi/TermBank/GetTermBankGroup',
    method: 'get',
    params,
  })
}
/** 获取字库项列表 */
export function getTermBankGroupItem(params: Object) {
  return request<Record<string, any>>({
    url: 'CommonApi/TermBank/GetTermBankGroupItem',
    method: 'get',
    params,
  })
}
